import { NextPage, NextPageContext } from 'next';
import React from 'react';

import { CampgroundPhotos } from '@/components/route/campground/CampgroundPhotos';
import { getRvBundlesListing } from '@/redux/modules/campgroundListing';
import { redirectToSearch, withRedirectToSearch } from '@/services/redirectToSearch';
import { ICampgroundData } from '@/services/types/search/campgrounds/id';
import { IStore } from '@/utility/redux/store';

const ListingPhotos: NextPage = () => {
  return <CampgroundPhotos isRVBundle />;
};

ListingPhotos.getInitialProps = withRedirectToSearch(
  async ({ res, query, pathname, reduxStore }: NextPageContext & { reduxStore: IStore }) => {
    const { slug, location: _, ...remainingParams } = query;
    // campground.vacation_package_slug has NOT been renamed to escapes yet!
    const escapesSlug = `/vacation-packages/${slug}`;
    const state = reduxStore.getState();
    const hasListingData = state.campgroundListing.data?.vacation_package_slug === escapesSlug;

    // get the campground listing but catch 404 errors from redux and redirect to search
    let campgroundListing: ICampgroundData | null = null;
    try {
      campgroundListing = hasListingData
        ? null
        : await reduxStore.dispatch(getRvBundlesListing(escapesSlug, remainingParams));
    } catch (error) {
      if (error.message === '404') {
        return redirectToSearch({ res, query });
      }

      throw error;
    }

    const campgroundData = state.campgroundListing.data || campgroundListing;

    if (campgroundData?.hidden || campgroundData?.has_been_published === false) {
      return redirectToSearch({ res, query }, pathname);
    }

    return { query, pathname, props: {} };
  },
);

export default ListingPhotos;
